import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "./ListNav.css";

class ListNav extends Component {
  render() {
    const { classes, list } = this.props;
    return (
      <ul className={classes.listStyle}>
        {list.map((item, i) => (
          <li key={i} className={classes.itemList}>
            <Link to={item.path} className={classes.labelStyle}>
              <div className={classes.sectionMobile}>{item.icon}</div>
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}

export default withStyles(useStyles)(ListNav);
